// extracted by mini-css-extract-plugin
export default {"productQuoteItem":"ProductQuoteItem_productQuoteItem__MXeK7"};